<template>
  <section
    :class="{
      'service-work': true,
      'service-work_no-border': noBorder,
    }"
  >
    <div class="osk-wrapper">
      <h2 class="section-title service-work__title">
        {{ $t('components.home.old.serviceWork.title') }}
      </h2>

      <div class="service-work__subtitle">
        {{ $t('components.home.old.serviceWork.subtitle') }}
      </div>

      <div class="service-work__buttons">
        <a
          href="#"
          :class="{
            'service-work__button': true,
            active: isBuyers
          }"
          @click.prevent="changeActiveBlock(InfoBlock.Buyers)"
        >{{ $t('components.home.old.serviceWork.forBuyer') }}</a>

        <a
          href="#"
          :class="{
            'service-work__button': true,
            active: isSellers
          }"
          @click.prevent="changeActiveBlock(InfoBlock.Sellers)"
        >{{ $t('components.home.old.serviceWork.forSeller') }}</a>
      </div>

      <div class="service-work__blocks">
        <div
          v-if="isBuyers"
          class="service-work__block"
        >
          <ul class="service-work__list">
            <li class="service-work__item">
              <div class="service-work__icon">
                <ChoicePaymentSVG class="service-work__icon-svg" />
                <span class="service-work__count">1</span>
              </div>

              <div>
                <div class="service-work__name">
                  {{ $t('components.home.old.serviceWork.block1.title') }}
                </div>
                <p class="service-work__name-text">
                  {{ $t('components.home.old.serviceWork.block1.text') }}
                </p>
              </div>
            </li>

            <li class="service-work__item">
              <div class="service-work__icon">
                <AuthenticationSVG class="service-work__icon-svg" />
                <span class="service-work__count">2</span>
              </div>

              <div>
                <div class="service-work__name">
                  {{ $t('components.home.old.serviceWork.block2.title') }}
                </div>
                <p class="service-work__name-text">
                  {{ $t('components.home.old.serviceWork.block2.text') }}
                </p>
              </div>
            </li>

            <li class="service-work__item">
              <div class="service-work__icon">
                <SendingGoodsSVG class="service-work__icon-svg" />
                <span class="service-work__count">3</span>
              </div>

              <div>
                <div class="service-work__name">
                  {{ $t('components.home.old.serviceWork.block3.title') }}
                </div>
                <p class="service-work__name-text">
                  {{ $t('components.home.old.serviceWork.block3.text') }}
                </p>
              </div>
            </li>
          </ul>

          <video
            class="service-work__video"
            controls=""
            muted=""
            poster="https://static.oskelly.ru/images/video-poster/video_home_2_poster.jpg"
            preload="none"
          >
            <source
              src="https://static.oskelly.ru/video/video_home_2.mp4"
              type="video/mp4"
            >
          </video>
        </div>

        <div
          v-if="isSellers"
          class="service-work__block"
        >
          <ul class="service-work__list">
            <li class="service-work__item">
              <div class="service-work__icon">
                <ProductPlacementSVG class="service-work__icon-svg" />
                <span class="service-work__count">1</span>
              </div>

              <div>
                <div class="service-work__name">
                  {{ $t('components.home.old.serviceWork.block4.title') }}
                </div>
                <p class="service-work__name-text">
                  {{ $t('components.home.old.serviceWork.block4.text') }}
                </p>
              </div>
            </li>

            <li class="service-work__item">
              <div class="service-work__icon">
                <Authentication2SVG class="service-work__icon-svg" />
                <span class="service-work__count">2</span>
              </div>

              <div>
                <div class="service-work__name">
                  {{ $t('components.home.old.serviceWork.block5.title') }}
                </div>
                <p class="service-work__name-text">
                  {{ $t('components.home.old.serviceWork.block5.text') }}
                </p>
              </div>
            </li>

            <li class="service-work__item">
              <div class="service-work__icon">
                <MoneyTransferSVG class="service-work__icon-svg" />
                <span class="service-work__count">3</span>
              </div>

              <div>
                <div class="service-work__name">
                  {{ $t('components.home.old.serviceWork.block6.title') }}
                </div>
                <p class="service-work__name-text">
                  {{ $t('components.home.old.serviceWork.block6.text') }}
                </p>
              </div>
            </li>
          </ul>

          <video
            class="service-work__video"
            controls=""
            muted=""
            preload="none"
          >
            <source
              src="https://static.oskelly.ru/video/video_home_1.mp4"
              type="video/mp4"
            >
          </video>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import ChoicePaymentSVG from '~/assets/img/home/choice-payment.svg?component';
import AuthenticationSVG from '~/assets/img/home/authentication.svg?component';
import SendingGoodsSVG from '~/assets/img/home/sending-goods.svg?component';
import ProductPlacementSVG from '~/assets/img/home/product-placement.svg?component';
import Authentication2SVG from '~/assets/img/home/authentication2.svg?component';
import MoneyTransferSVG from '~/assets/img/home/money-transfer.svg?component';

enum InfoBlock {
  Buyers = 'buyers',
  Sellers = 'sellers'
}

const props = defineProps<{
  noBorder?: boolean
}>();

const activeBlock = ref(InfoBlock.Buyers);

const isBuyers = computed(() => activeBlock.value === InfoBlock.Buyers);
const isSellers = computed(() => activeBlock.value === InfoBlock.Sellers);

function changeActiveBlock(value: InfoBlock) {
  activeBlock.value = value;
}
</script>

<style scoped lang="scss">
.service-work {
  border-bottom: 1px solid #eee;
  padding: 44px 0;

  &_no-border {
    border-bottom: 0;
  }

  @media screen and (min-width: 767px) {
    padding: 60px 0;
  }

  &__title {
    text-align: center;
    margin-bottom: 24px;

    @media screen and (min-width: 767px) {
      margin-bottom: 16px;
    }
  }

  &__subtitle {
    display: none;

    @media screen and (min-width: 767px) {
      display: block;
      max-width: 480px;
      margin: 0 auto;
      color: #828282;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      margin-bottom: 32px;
    }

    @media screen and (min-width: 1024px) {
      max-width: 550px;
    }
  }

  &__buttons {
    display: flex;
    justify-content: center;
  }

  &__button {
    background: rgba(51,51,51,.05);
    text-transform: uppercase;
    text-align: center;
    display: block;
    color: #333;
    transition: .3s;
    font-size: 12px;
    letter-spacing: 0;
    font-weight: 600;
    padding: 11px 0;
    width: 50%;

    &:hover {
      background: rgba(51,51,51,.15);
    }

    &.active {
      color: #fff;
      background: #333;
    }

    @media screen and (min-width: 767px) {
      font-size: 14px;
      letter-spacing: .3px;
      padding: 15px 0;
      width: 250px;
    }
  }

  &__blocks {
    margin-top: 29px;

    @media screen and (min-width: 767px) {
      margin-top: 55px;
    }
  }

  &__block {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__video {
    display: none;
    width: 100%;
    height: 100%;

    @media screen and (min-width: 1024px) {
      width: 55%;
      max-height: 355px;
      display: block;
    }

    @media screen and (min-width: 1250px) {
      width: 630px;
    }
  }

  &__list {
    @media screen and (min-width: 767px) {
      display: flex;
      justify-content: space-between;
    }

    @media screen and (min-width: 1024px) {
      display: block;
      width: 45%;
      max-width: 100%;
    }
  }

  &__item {
    margin-bottom: 30px;
    display: flex;

    @media screen and (min-width: 767px) {
      width: calc(33.33333% - 20px);
      margin-bottom: 0;
      display: block;
    }

    @media screen and (min-width: 1024px) {
      display: flex;
      margin-bottom: 50px;
      width: 100%;
    }
  }

  &__icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    position: relative;
    background: #f2f2f2;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;

    @media screen and (min-width: 767px) {
      margin-bottom: 13px;
    }

    @media screen and (min-width: 1024px) {
      width: 72px;
      height: 72px;
      margin-bottom: 0;
      margin-right: 32px;
    }
  }

  &__icon-svg {
    max-width: 46%;
  }

  &__count {
    position: absolute;
    display: block;
    border-radius: 50%;
    top: -2px;
    right: -3px;
    color: #fff;
    background: #333;
    text-align: center;
    width: 16px;
    height: 16px;
    font-size: 10px;
    line-height: 16px;

    @media screen and (min-width: 1024px) {
      width: 24px;
      height: 24px;
      font-size: 13px;
      line-height: 24px;
    }
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;

    @media screen and (min-width: 1024px) {
      font-size: 16px;
    }

    &-text {
      font-size: 12px;
      line-height: 18px;

      @media screen and (min-width: 1024px) {
        font-size: 14px;
        line-height: 21px;
        padding-right: 24px;
      }
    }
  }
}
</style>
